import './index.css'
import cn from 'clsx'
import React from 'react'
import ReactDOM from 'react-dom'
import usePreventScroll from 'hooks/use-prevent-scroll'
type Props = {
  children: React.ReactNode
  open: boolean
}

/**
 * PlayerPane component for displaying player content in a portal overlay
 *
 * Creates a full-screen overlay pane that renders content in a portal attached to document.body.
 * Prevents scrolling when open and provides a container for player-related UI elements.
 *
 * @param props - Component props
 * @param props.children - React nodes to render inside the pane
 * @param props.open - Whether the pane is currently open/visible
 * @returns Portal-rendered JSX element containing the player pane
 */
const PlayerPane = ({ children, open }: Props): any => {
  usePreventScroll(open)

  const renderPortal = (container: HTMLElement) => {
    return ReactDOM.createPortal(
      <div
        className={cn('PlayerPane', {
          'PlayerPane--open': open,
        })}
      >
        <div className="PlayerPane-container">{children}</div>
      </div>,
      container,
    )
  }

  return document.body ? renderPortal(document.body) : null
}

export default PlayerPane
